import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('new_group_of_values'),
    create: defineMessage('create'),
    requiredField: defineMessage('field_is_required'),
    fieldType: defineMessage('field_type_1'),
    groupName: defineMessage('group_name'),
    enterName: defineMessage('enter_name'),
    account: defineMessage('account'),
    fieldTypeHint: defineMessage('only_account_is_currently_available'),
    successMessage: defineMessage('group_of_accounts_has_been_successfully_created'),
    conflictErrorMessage: defineMessage('another_group_already_exists_with_this_name'),
};
